export const guardianSetItem = {
    binary: "uint",
    size: 4,
};
//# sourceMappingURL=guardianSet.js.map